import { I18nProvider as SharedProvider, useI18n, LanguageSelector, mergeTranslations } from 'shared/i18n';
import en from './en.json';
import es from './es.json';
import { datasourcesTranslations } from '@/features/datasources/i18n';
import { emailDashboardTranslations } from '@/features/email-dashboard/i18n';
import { secretsTranslations } from '@/features/secrets/i18n';
import { llmConfigTranslations } from '@/features/llm-config/i18n';
import { skillsTranslations } from '@/features/skills/i18n';
import { frontierTranslations } from '@/features/frontier/i18n';
import { modelIntelligenceTranslations } from '@/features/model-intelligence/i18n';
import { aiGatewayTranslations } from '@/features/ai-gateway/i18n';
import type { ReactNode } from 'react';

const tierTranslations: Record<string, Record<string, unknown>> = {
  en: mergeTranslations(
    en as Record<string, unknown>,
    datasourcesTranslations.en as Record<string, unknown>,
    emailDashboardTranslations.en as Record<string, unknown>,
    secretsTranslations.en as Record<string, unknown>,
    llmConfigTranslations.en as Record<string, unknown>,
    skillsTranslations.en as Record<string, unknown>,
    frontierTranslations.en as Record<string, unknown>,
    modelIntelligenceTranslations.en as Record<string, unknown>,
    aiGatewayTranslations.en as Record<string, unknown>,
  ),
  es: mergeTranslations(
    es as Record<string, unknown>,
    datasourcesTranslations.es as Record<string, unknown>,
    emailDashboardTranslations.es as Record<string, unknown>,
    secretsTranslations.es as Record<string, unknown>,
    llmConfigTranslations.es as Record<string, unknown>,
    skillsTranslations.es as Record<string, unknown>,
    frontierTranslations.es as Record<string, unknown>,
    modelIntelligenceTranslations.es as Record<string, unknown>,
    aiGatewayTranslations.es as Record<string, unknown>,
  ),
};

interface Props {
  children: ReactNode;
  defaultLocale?: 'en' | 'es';
}

export function I18nProvider({ children, defaultLocale }: Props) {
  return (
    <SharedProvider translations={tierTranslations} defaultLocale={defaultLocale}>
      {children}
    </SharedProvider>
  );
}

export { useI18n, LanguageSelector };
export type { Locale, I18nContextType } from 'shared/i18n';
